"use client"
import React, { createContext, useContext, useState, useCallback } from 'react';

const FlashMessageContext = createContext(null);

let idCounter = 0;

export const FlashMessageProvider = ({ children }) => {
  const [messages, setMessages] = useState([]);
  const [confirmDialog, setConfirmDialog] = useState(null);

  // Standard toast message
  const addMessage = useCallback((type, message) => {
  const id = idCounter++;

  // ✅ Safely stringify message if it's an object or non-string
  const safeMessage =
    typeof message === 'object'
      ? JSON.stringify(message)
      : String(message ?? '');

  setMessages(prev => [...prev, { id, type, message: safeMessage }]);

  setTimeout(() => {
    setMessages(prev => prev.filter(msg => msg.id !== id));
  }, 7000);
}, []);


  const removeMessage = useCallback(id => {
    setMessages(prev => prev.filter(msg => msg.id !== id));
  }, []);

  // Confirmation toast with Yes/No
  const confirm = useCallback((message, onYes, onNo) => {
    setConfirmDialog({ message, onYes, onNo });
  }, []);

  const handleConfirm = (result) => {
    if (result && confirmDialog?.onYes) confirmDialog.onYes();
    if (!result && confirmDialog?.onNo) confirmDialog.onNo();
    setConfirmDialog(null);
  };

  return (
    <FlashMessageContext.Provider value={{ addMessage, confirm }}>
      {children}
      <div id="flash-container">
        {messages.map(({ id, type, message }) => (
          <div key={id} className={`flash-${type} flash-float flash-message-flex`}>
            <span className="flash-message-text">{message}</span>
            <button className="close-btn" onClick={() => removeMessage(id)}>x</button>
          </div>
        ))}
        {confirmDialog && (
          <div className="flash-warning flash-float" style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
            <span>{confirmDialog.message}</span>
            <div style={{ marginTop: "10px", display: "flex", gap: "10px" }}>
              <button
                className="btn btn-sm"
                style={{
                  backgroundColor: "#BB3C2D",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  padding: "6px 18px",
                  fontWeight: "bold",
                }}
                onClick={() => handleConfirm(true)}
              >
                Yes
              </button>
              <button
                className="btn btn-sm"
                style={{
                  backgroundColor: "#E4E4E7",
                  color: "black",
                  border: "none",
                  borderRadius: "4px",
                  padding: "6px 18px",
                  fontWeight: "bold",
                }}
                onClick={() => handleConfirm(false)}
              >
                No
              </button>
            </div>
          </div>
        )}
      </div>
    </FlashMessageContext.Provider>
  );
};


export const useFlash = () => {
  const context = useContext(FlashMessageContext);
  if (!context) throw new Error("useFlash must be used within FlashMessageProvider");
  return context;
};